// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"358":"live-streaming","594":"about","977":"medical-code"}[chunkId] || chunkId) + "." + {"358":"bec4f52e","551":"0acf17f5","594":"a47b4f6e","610":"7d0619d3","847":"bb1b8533","977":"669eeaf0"}[chunkId] + ".js";
};